import React, { useState } from "react";
import {
  BiRightArrowAlt,
  BiSolidArrowToRight,
  BiSolidXCircle,
  BiXCircle,
  BiImage,
  BiTrashAlt,
  BiCheckboxChecked,
  BiComment,
} from "react-icons/bi";
import { arrayMoveImmutable } from "array-move";
import {
  BsArrow90DegRight,
  BsArrowRigh,
  BsHandThumbsUp,
  BsHandThumbsUpFill,
  BsHandThumbsDown,
  BsHandThumbsDownFill,
} from "react-icons/bs";
import ReactTooltip from "react-tooltip";
import { Alert, Button, Col, Input, Label, Popover, Row } from "reactstrap";
import {
  CUSTOM_QUESTION_INPUT_TYPES,
  MAX_OPTIONS_ARRAY,
  MIN_OPTIONS_ARRAY,
  renderCommentsCountTextFormat,
  THEME_SETTING,
} from "../data";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import GrpBannerModal from "../../groups/Components/GrpBannerModal";
import QuizTextEditor from "../../../components/QuizTextEditor/QuizTextEditor";
import parse from "html-react-parser";
import UploadMediaModal from "./UploadMediaModal";
import ReactPlayer from "react-player";
import StarRatings from "react-star-ratings";
import Select from "react-select";
import RangeInput from "../../../components/RangeInput/RangeInput";
import { FaComment, FaRecycle, FaRegComment } from "react-icons/fa6";
import Toggle from "react-toggle";
import TriviaCommentsComponent from "./TriviaCommentsComponent";
import SortableList, { SortableItem } from "react-easy-sort";

export default function TriviaQuestionsComponent({
  question,
  editQuestion,
  view,
  themeSettings,
  callApiToAutoSave,
  generateOptionId,
  editQuestionOptionsSync,

  isEditable,
  regenerateQuestion,
  isBannerOpen,
  setIsBannerOpen,
  triviaId,
  questionComments,
  updateTriviaComments,
}) {
  const [hoveredOption, setHoveredOption] = useState(null);

  const [demoRangeVal, setDemoRangeVal] = useState(0);

  const [commentsPopoverOpen, setCommentsPopoverOpen] = useState(false);

  // const openBannerModal = () => {
  //   setIsBannerOpen(!isBannerOpen);
  // };

  const setBannerImg = image => {
    const doc = {
      ...question,
    };

    console.log("herererer");

    if (image.file) {
      const formData = new FormData();

      formData.append("image", image.file);

      axios
        .post(url.uploadTriviaImages, formData)
        .then(({ data }) => {
          console.log('87 --- ', data)
          doc["media_url"] = [
            { url: data.data.url, 
              s3Key: data.data.s3Key,
              type: image.type, 
              uploaded: true },
          ];
          editQuestion(doc, "media_url");
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      doc.media_url = [{ url: image.url, type: image.type, uploaded: false }];
      console.log("klklklkl");
      editQuestion(doc, "media_url");
    }
  };

  const removeBannerImg = () => {
    const data = {
      ...question,
      media_url: [],
    };

    editQuestion(data, "media_url");
  };

  const getOptionName = index => {
    const str = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

    return str[index];
  };

  const isMobile = view === "MOBILE";

  const editQuestionText = value => {
    const queData = {
      ...question,
      question_text: value.replace(/<p><\/p>/gi, ""),
    };

    editQuestion(queData, "question_text");
  };
  const editQuestionReqToggle = value => {
    const queData = {
      ...question,
      isRequired: value,
    };

    editQuestion(queData, "question_text");
  };

  const editOptionsText = (index, value) => {
    let optionsArr = [...question.options];
    optionsArr[index] = { ...optionsArr[index], text: value };
    const queData = {
      ...question,
      options: [...optionsArr],
    };

    editQuestion(queData, "options");
  };
  const addOptionsText = value => {
    let optionsArr = [...question.options];
    optionsArr.push({
      text: value,
      option_order: optionsArr.length + 1,
      option_id: generateOptionId(value, optionsArr.length + 1),
    });
    const queData = {
      ...question,
      options: [...optionsArr],
    };

    editQuestionOptionsSync(queData, "options");
  };

  const removeOption = index => {
    let optionsArr = [...question.options];
    optionsArr.splice(index, 1);

    const queData = {
      ...question,
      options: [...optionsArr],
    };

    editQuestion(queData, "options");
  };

  const mediaObject =
    question.media_url &&
    Array.isArray(question.media_url) &&
    question.media_url.length > 0
      ? question.media_url[0]
      : null;

  const changeRating = val => {
    const queData = {
      ...question,
      rating: val,
    };
    editQuestion(queData, "rating");
  };

  const handleQuestionTypeChange = val => {
    const queData = {
      ...question,
      question_type: val,
    };
    if (val != "MCQ") {
      // queData.correct_options = [];
      // queData.options = [];
      // queData.source = "";
      // queData.is_ai_generated = false;
    }
    editQuestion(queData, "question_type");
  };

  const changeLinearNumericConfigs = value => {
    const queData = {
      ...question,
      linearNumericConfigs: value,
    };
    editQuestion(queData, "linearNumericConfigs");
  };

  console.log("question.linearNumericConfigs--- ", question);

  if (
    !question.linearNumericConfigs ||
    question.hasOwnProperty("linearNumericConfigs") == false
  ) {
    console.log("question ---- inside");
    question.linearNumericConfigs = { max: 10, min: 0 };
  }

  let isVideoUploadQ = false;

  if (
    mediaObject &&
    mediaObject.type &&
    mediaObject.type.indexOf("video") > -1
  ) {
    isVideoUploadQ = true;
  }

  const setComments = comments => {
    const queData = {
      ...question,
      commentsCount: comments.length,
    };
    updateTriviaComments(question.question_id, comments);
    editQuestion(queData, "comments");
  };

  const onSortEnd = (oldIndex, newIndex) => {
    const sortedArray = arrayMoveImmutable(
      question.options,
      oldIndex,
      newIndex
    );
    const queData = {
      ...question,
      options: sortedArray,
    };
    editQuestion(queData, "options");
  };

  return (
    <div>
      <div
        className={`${isEditable ? "" : "trivia-edit-disabled-add-opacity"} ${
          isMobile
            ? "trivia-survey-edit-questions-ui-mobile py-0"
            : "trivia-survey-edit-questions-ui py-5"
        }`}
        style={{
          backgroundColor: themeSettings.quizBackgroundColor,
          color: themeSettings.quizTextColor,
          position:"relative"
          // display: "flex",
          // flexDirection: "row",
        }}
      >
        <div
          className={
            !isMobile
              ? "trivia-survey-edit-questions-ui_centerUI mt-4"
              : "trivia-survey-edit-questions-ui_centerUI_mobile mt-2"
          }
          style={{ width: "100%", paddingLeft: "15px" ,display:"block"}}
        >
          <div style={{ flex: 1 }}>
   
          {isMobile && (
                    <div className="my-2">
                   

                      <Select
                        options={CUSTOM_QUESTION_INPUT_TYPES}
                        value={question.question_type}
                        placeholder="Select question type..."
                        onChange={isEditable? x => handleQuestionTypeChange(x.value):null}
                        className="question_type_select w-100"
                        disabled={!isEditable}
                      />

                      <span
                        onClick={() => setIsBannerOpen(true)}
                        className="cursor-pointer mt-3 font-styling-right-sidebar-items"
                      >
                        Add media/images <BiImage size={24} className="mr-1" />
                      </span>
                    </div>
                  )}
            {/* {question.rating > 0 && question.rating <= 2 ? (
            <div>
              <Alert color="warning">
                You have rated this question less click here to Regenerate{" "}
                <Button
                  onClick={() => regenerateQuestion(question)}
                  className="trivia-action-button-main w-150 ml-3"
                >
                  Regenerate
                </Button>
              </Alert>
            </div>
          ) : (
            ""
          )} */}
            {/* <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "50px",
            }}
          >
            <h6> Please rate the question:</h6>
            <div>
              <StarRatings
                rating={question.rating || 0}
                starRatedColor={themeSettings.quizTextColor}
                changeRating={changeRating}
                numberOfStars={5}
                name="rating"
                starDimension="30px"
                starSpacing="4px"
              />
            </div>
          </div> */}
            <div
              className="trivia-survey-edit-questions-ui_question_title"
              // data-tip={
              //   !question.is_ai_generated
              //     ? ""
              //     : "Cant edit Ai Generated Questions"
              // }
            >
              <span className="trivia-survey-edit-questions-ui_question_title_qPointer">
                {question.order}{" "}
                <BiRightArrowAlt className="font-weight-bolder" size={16} />{" "}
              </span>{" "}
              <div
                className="trivia_edit_q_wrap_p_start"
                style={{
                  display: "flex",
                  // alignItems: "center",
                }}
              >
                <div
                  className="trivia_edit_q_wrap_p_start_textarea_container"
                  // style={{
                  //   width: "80%",
                  //   marginBottom: "20px",
                  //   // paddingTop: "15px",
                  // }}
                >
                 
                  <QuizTextEditor
                    value={question.question_text}
                    onChange={value => editQuestionText(value)}
                    styles={{
                      fontSize: isMobile ? "15px": "19px",
                      maxWidth: "100%",
                      width: "100%",
                    }}
                    placeholder="Enter Question Here ...."
                    questionId={question.question_id}
                    disabled={!isEditable}
                    toolbarBottom
                    blockId="xx"
                    questionThemeSettings={themeSettings}
                  />
                </div>

                {!isMobile && (
                  <div style={{ width: "20%", paddingTop: "15px" }}>
                    <Select
                      options={CUSTOM_QUESTION_INPUT_TYPES}
                      value={question.question_type}
                      placeholder="Select question type..."
                      onChange={x => handleQuestionTypeChange(x.value)}
                      className="question_type_select"
                      disabled={!isEditable}
                    />

                   

                    {/* {isEditable &&
                  question.question_type == "MCQ" &&
                  question.is_ai_generated ? (
                    <div>
                      <span
                        onClick={() => regenerateQuestion(question)}
                        className="cursor-pointer"
                      >
                        <FaRecycle className="mr-1" /> Regenerate{" "}
                      </span>
                    </div>
                  ) : (
                    ""
                  )} */}
                  </div>
                )}
              </div>
              {/* )} */}
              <ReactTooltip />
            </div>

            {
              !isMobile &&   <div className="mt-3 mb-3 float-right">
              <span
                onClick={isEditable? () => setIsBannerOpen(true):null}
                className="cursor-pointer ml-4  mt-4 font-styling-right-sidebar-items"
              >
                Add media/images <BiImage size={24} className="mr-1" />
              </span>
            </div>
            }

          

            {/* {!question.is_ai_generated && ( */}
           
            {/* )} */}

            {/* {
            question.question_type != "MCQ" && 
            <div className="mt-5 mb-2">
                  <Toggle
                    checked={question.isRequired}
                    onChange={(e) => {
                      editQuestionReqToggle(e.target.checked);
                    }}
                  />
  
                  <span className={"text-danger ml-2"}>*Required</span>
                </div>
          } */}

            <div className={`mt-3 ${isMobile ? "pr-3" :"pl-5"}  pt-1 trivia-survey-edit-questions-ui_options_container`}>
              {question.question_type == "MCQ" ? (
                <div>
                  <SortableList
                    className={`row ${!isMobile &&
                      "trivia_edit_options_row_mapping"}`}
                    onSortEnd={onSortEnd}
                    draggedItemClassName="dragged"
                  >
                    {question.options.map((x, idx) => {
                      const isCorrect = question.correct_options[0]
                        ? x.option_id == question.correct_options[0].option_id
                        : false;
                      return (
                        <SortableItem key={x.option_id}>
                          <div
                            className={`px-2 py-1 d-flex ${
                              isMobile ? "col-sm-12" : "col-sm-4"
                            }`}
                          >
                            <div
                              className="trivia-survey-edit-questions-ui_option_item"
                              onMouseEnter={() => setHoveredOption(idx)}
                              onMouseLeave={() => setHoveredOption(null)}
                              style={{
                                flexGrow: 1,
                                // backgroundColor: themeSettings.quizTextColor.replace(
                                //   ")",
                                //   ",0.1)"
                                // ),
                                // border: `1px solid ${themeSettings.quizTextColor}`,

                                backgroundColor:
                                  hoveredOption === idx && !isCorrect
                                    ? themeSettings.quizTextColor
                                      
                                    : isCorrect
                                    ? "green"
                                    : "white",
                                color: isCorrect
                                  ? "white"
                                  : hoveredOption === idx
                                  ? themeSettings.quizBackgroundColor
                                    
                                  : "black",
                                boxShadow: ` 0px 0px 0px 1px ${
                                  !isCorrect
                                    ? themeSettings.quizTextColor.replace(
                                        ")",
                                        ",0.6)"
                                      )
                                    : "green"
                                }`,
                                paddingRight: "12px"
                              }}
                            >
                              <span className="option_name_wrapper">
                                {getOptionName(idx)}
                              </span>

                              <QuizTextEditor
                                value={x.text}
                                onChange={e => {
                                  editOptionsText(idx, e);
                                }}
                                styles={{
                                  fontSize: "13px",
                                  maxHeight: "200px",
                                  width: "100%",
                                }}
                                placeholder="Enter Option ...."
                                hideToolbar
                                questionId={x.option_id}
                                disabled={!isEditable}
                                questionThemeSettings={themeSettings}
                              />

                              {isEditable && hoveredOption === idx && (
                                <BiXCircle
                                  className="trivia_questions_ui_remove_option_cross"
                                  color="white"
                                  size={24}
                                  onClick={() => removeOption(idx)}
                                />
                              )}
                            </div>
                          </div>
                        </SortableItem>
                      );
                    })}
                    {isEditable && (
                      <Col sm={isMobile ? 12 : 4} className="m_t_auto">
                        <span
                          style={{
                            textDecoration: "underline",
                            cursor: "pointer",
                            marginTop: "auto",
                            marginBottom: "12px",
                          }}
                          onClick={() =>
                            addOptionsText(
                              `Choice ${question.options.length + 1}`
                            )
                          }
                          className="mt-4"
                        >
                          {" "}
                          Add choice{" "}
                        </span>
                      </Col>
                    )}
                  </SortableList>
                  {/* {!question.is_ai_generated && ( */}

                  {/* {
                    question.question_type ==="MCQ" && !question.is_ai_generated && (question.correct_options && !question.correct_options[0])  ? 
                    <Alert style={{marginLeft:"-10px"}} color="warning">You have the option to select a correct answer on the right hand side.</Alert> 
                    :""
                  } */}
                </div>
              ) : question.question_type == "TEXT" ? (
                <Input
                  type={"textarea"}
                  className={`question_component_sample_input ${isMobile ? "mr-3" :"ml-4"}`}
                  placeholder="Text input here ..."
                  value={""}
                  onChange={e => {}}
                  rows={5}
                />
              ) : (
                <div className="question_edit_min_max_ui">
                  <RangeInput
                    className="mt-2"
                    min={question.linearNumericConfigs.min}
                    max={question.linearNumericConfigs.max}
                    value={demoRangeVal}
                    onChange={v => setDemoRangeVal(v)}
                    themeSettings={question.theme_settings}
                    options={question.isLikert ? question.options || [] : []}
                  />

                  <div className="mt-4">
                    <div className="d-flex align-items-center">
                      <div>
                        <Select
                          options={MIN_OPTIONS_ARRAY.filter(
                            x => x.value < question.linearNumericConfigs.max
                          )}
                          className="w-70"
                          value={question.linearNumericConfigs.min || 1}
                          placeholder="Set Minimum"
                          onChange={e =>
                            changeLinearNumericConfigs({
                              ...question.linearNumericConfigs,
                              min: e.value,
                            })
                          }
                          disabled={!isEditable}
                        />
                      </div>
                      <div className="mx-2">to</div>
                      <div>
                        <Select
                          options={MAX_OPTIONS_ARRAY}
                          className="ml-1 w-70"
                          value={question.linearNumericConfigs.max}
                          placeholder="Set Maximum"
                          onChange={e =>
                            changeLinearNumericConfigs({
                              ...question.linearNumericConfigs,
                              max: e.value,
                            })
                          }
                          disabled={!isEditable}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div
              // className="mt-4"
              style={{
                marginBlockStart: isMobile ? "0px" : "1em",
                paddingInlineStart: isMobile ? "0px" : "0px",
                width: "80%",
              }}
            >
              {mediaObject && mediaObject.url ? (
                <div style={{ position: "relative", marginTop: "30px" }}>
                  <div
                    className="trivia_question_image_upload"
                    // style={{ minHeight: isMobile ? "100px" : "200px" }}
                  >
                    {/* {isEditable ? (
                      <div
                        className="uploadTriviaImageText questionUpload"
                        data-tip="Change / Upload image"
                        style={{
                          position:
                            mediaObject &&
                            mediaObject.type &&
                            mediaObject.type.indexOf("video") > -1
                              ? "relative"
                              : "absolute",
                        }}
                      >
                        <span
                          className="trivia_survey_share_buttons_left_smallWrapper_dark"
                          onClick={() => setIsBannerOpen(true)}
                        >
                          <BiImage size={27} />
                        </span>{" "}
                      </div>
                    ) : (
                      ""
                    )} */}

                    {mediaObject && mediaObject.url ? (
                      <div
                        className="trivia-assets ml-5"
                        style={{
                          width: isVideoUploadQ ? "fit-content" : "inherit",
                        }}
                      >
                        {mediaObject &&
                        mediaObject.type &&
                        mediaObject.type.indexOf("video") > -1 ? (
                          <div
                            style={{
                              position: "relative",
                              width: "max-content",
                            }}
                          >
                            {mediaObject && mediaObject.url && (
                              <span
                                className="trivia_survey_share_buttons_left_smallWrapper_dark"
                                onClick={() => removeBannerImg()}
                                data-tip="Delete image"
                                style={{ position: "absolute", right: "0" }}
                              >
                                <BiTrashAlt size={27} />
                              </span>
                            )}
                            {mediaObject && mediaObject.url && (
                              <span
                                className="trivia_survey_share_buttons_left_smallWrapper_dark"
                                onClick={() => setIsBannerOpen(true)}
                                style={{ position: "absolute", right: "50px" }}
                              >
                                <BiImage size={27} />
                              </span>
                            )}
                            <ReactPlayer
                              height={isMobile ? "150px" : "160px"}
                              width="fit-content"
                              maxWidth={
                                isMobile ? "fit-content" : "fit-content"
                              }
                              controls={true}
                              loop={true}
                              playing
                              muted
                              playsinline
                              url={mediaObject && mediaObject.url}
                              style={{
                                backgroundColor: "black",
                                width: "fit-content!important",
                              }}
                            />
                          </div>
                        ) : (
                          <div
                            style={{
                              position: "relative",
                              width: "max-content",
                            }}
                          >
                            {mediaObject && mediaObject.url && (
                              <span
                                className="trivia_survey_share_buttons_left_smallWrapper_dark"
                                onClick={() => removeBannerImg()}
                                data-tip="Delete image"
                                style={{ position: "absolute", right: 0 }}
                              >
                                <BiTrashAlt size={27} />
                              </span>
                            )}
                            {mediaObject && mediaObject.url && (
                              <span
                                className="trivia_survey_share_buttons_left_smallWrapper_dark"
                                onClick={() => setIsBannerOpen(true)}
                                style={{ position: "absolute", right: "55px" }}
                              >
                                <BiImage size={27} />
                              </span>
                            )}

                            <img
                              src={mediaObject && mediaObject.url}
                              style={{
                                height: isMobile ? "150px" : "160px",
                                maxWidth: isMobile ? "275px" : "550px",
                                minWidth: "250px",
                              }}
                            />
                          </div>
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ) : (
                <div></div>
              )}
            </div>
            
          </div>
        </div>

        {isBannerOpen && (
          <UploadMediaModal
            open={isBannerOpen}
            onClose={() => setIsBannerOpen(false)}
            setBannerImg={setBannerImg}
           
            selectedMedia={question.media_url}
            removeBannerImg={removeBannerImg}
          
          />
        )}

       

        
      </div>

      <div className="trivvy-c-r-btns-wrapper">
        <div className="d-block trivvy-edit-q-container">
          <div
            className="cursor-pointer d-flex align-items-center"
            style={{
              float: "right",
            }}
          >
            <span className="font-styling-right-sidebar-items">
              {" "}
              Rate this question{" "}
            </span>
            <span>
              {question.rating === 1 ? (
                <BsHandThumbsUpFill
                  size={18}
                  className="ml-1"
                  color="#ff4500"
                />
              ) : (
                <BsHandThumbsUp
                  onClick={() => {
                    editQuestion(
                      {
                        ...question,
                        rating: 1,
                      },
                      "rating"
                    );
                  }}
                  size={18}
                  className="ml-1"
                  color="#ff4500"
                />
              )}
              {question.rating === 0 ? (
                <BsHandThumbsDownFill
                  size={18}
                  className="ml-2"
                  color="#ff4500"
                />
              ) : (
                <BsHandThumbsDown
                  onClick={() => {
                    editQuestion(
                      {
                        ...question,
                        rating: 0,
                      },
                      "rating"
                    );
                  }}
                  size={18}
                  className="ml-2"
                  color="#ff4500"
                />
              )}
            </span>
          </div>
        </div>
        <div className="d-block trivvy-comments-q-container">
          <div
            className="cursor-pointer d-flex align-items-center"
            style={{
              float: "right",
            }}
            onClick={() => setCommentsPopoverOpen(!commentsPopoverOpen)}
          >
            <span
              className="font-styling-right-sidebar-items mr-2"
              id={`comments-popover-x`}
            >
              {" "}
              Comments (
              {renderCommentsCountTextFormat(question.commentsCount) || 0})
            </span>
            <FaRegComment />
          </div>

          {commentsPopoverOpen && (
            <TriviaCommentsComponent
              commentsPopoverOpen={commentsPopoverOpen}
              setCommentsPopoverOpen={setCommentsPopoverOpen}
              target={`comments-popover-x`}
              comments={questionComments}
              setComments={setComments}
              questionId={question.question_id}
              triviaId={triviaId}
            />
          )}
        </div>
        </div>
    </div>
  );
}
